import _classCallCheck from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _get from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _getPrototypeOf from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import { WordArray, Hasher } from './core.js'; // Initialization and round constants tables

var H = [];
var K = []; // Compute constants

var isPrime = function isPrime(n) {
  var sqrtN = Math.sqrt(n);

  for (var factor = 2; factor <= sqrtN; factor += 1) {
    if (!(n % factor)) {
      return false;
    }
  }

  return true;
};

var getFractionalBits = function getFractionalBits(n) {
  return (n - (n | 0)) * 0x100000000 | 0;
};

var n = 2;
var nPrime = 0;

while (nPrime < 64) {
  if (isPrime(n)) {
    if (nPrime < 8) {
      H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
    }

    K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
    nPrime += 1;
  }

  n += 1;
} // Reusable object


var W = [];
/**
 * SHA-256 hash algorithm.
 */

export var SHA256Algo = /*#__PURE__*/function (_Hasher) {
  _inherits(SHA256Algo, _Hasher);

  var _super = _createSuper(SHA256Algo);

  function SHA256Algo() {
    _classCallCheck(this, SHA256Algo);

    return _super.apply(this, arguments);
  }

  _createClass(SHA256Algo, [{
    key: "_doReset",
    value: function _doReset() {
      this._hash = new WordArray(H.slice(0));
    }
  }, {
    key: "_doProcessBlock",
    value: function _doProcessBlock(M, offset) {
      // Shortcut
      var _H = this._hash.words; // Working variables

      var a = _H[0];
      var b = _H[1];
      var c = _H[2];
      var d = _H[3];
      var e = _H[4];
      var f = _H[5];
      var g = _H[6];
      var h = _H[7]; // Computation

      for (var i = 0; i < 64; i += 1) {
        if (i < 16) {
          W[i] = M[offset + i] | 0;
        } else {
          var gamma0x = W[i - 15];
          var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
          var gamma1x = W[i - 2];
          var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
          W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
        }

        var ch = e & f ^ ~e & g;
        var maj = a & b ^ a & c ^ b & c;
        var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
        var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
        var t1 = h + sigma1 + ch + K[i] + W[i];
        var t2 = sigma0 + maj;
        h = g;
        g = f;
        f = e;
        e = d + t1 | 0;
        d = c;
        c = b;
        b = a;
        a = t1 + t2 | 0;
      } // Intermediate hash value


      _H[0] = _H[0] + a | 0;
      _H[1] = _H[1] + b | 0;
      _H[2] = _H[2] + c | 0;
      _H[3] = _H[3] + d | 0;
      _H[4] = _H[4] + e | 0;
      _H[5] = _H[5] + f | 0;
      _H[6] = _H[6] + g | 0;
      _H[7] = _H[7] + h | 0;
    }
  }, {
    key: "_doFinalize",
    value: function _doFinalize() {
      // Shortcuts
      var data = this._data;
      var dataWords = data.words;
      var nBitsTotal = this._nDataBytes * 8;
      var nBitsLeft = data.sigBytes * 8; // Add padding

      dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
      dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
      dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
      data.sigBytes = dataWords.length * 4; // Hash final blocks

      this._process(); // Return final computed hash


      return this._hash;
    }
  }, {
    key: "clone",
    value: function clone() {
      var clone = _get(_getPrototypeOf(SHA256Algo.prototype), "clone", this).call(this);

      clone._hash = this._hash.clone();
      return clone;
    }
  }]);

  return SHA256Algo;
}(Hasher);
/**
 * Shortcut function to the hasher's object interface.
 *
 * @param {WordArray|string} message The message to hash.
 *
 * @return {WordArray} The hash.
 *
 * @static
 *
 * @example
 *
 *     var hash = CryptoJS.SHA256('message');
 *     var hash = CryptoJS.SHA256(wordArray);
 */

export var SHA256 = Hasher._createHelper(SHA256Algo);
/**
 * Shortcut function to the HMAC's object interface.
 *
 * @param {WordArray|string} message The message to hash.
 * @param {WordArray|string} key The secret key.
 *
 * @return {WordArray} The HMAC.
 *
 * @static
 *
 * @example
 *
 *     var hmac = CryptoJS.HmacSHA256(message, key);
 */

export var HmacSHA256 = Hasher._createHmacHelper(SHA256Algo);